import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../BaseUrl";
import { toastError, toastSuccess } from "../../../../Toast/Toast";
import { appendVideoFormData } from "../../../../VideoFormData";

export const POST_M_SeminarVideoMaster_InsertAPI = createAsyncThunk(
    "POST_M_SeminarVideoMaster_Insert",
    async ({ data }) => {
        const {
            SeminarVideoID,
            TitleName,
            SubTitleName,
            Description,
            VideoList,
            M_UserID,
            token,
            handleIsPost,
            setloader,
            ScreenType,
            Video_PurchaseAmount
        } = data

        const isUpdate = ScreenType === "Update"
        const videoList = VideoList || []

        const myHeaders = new Headers()
        myHeaders.append("Accept", "application/json")
        if (token) {
            myHeaders.append("Authorization", "Bearer " + token)
        }

        // Body
        const formdata = new FormData()
        if (isUpdate) {
            formdata.append("SeminarVideoID", SeminarVideoID)
        }
        formdata.append("TitleName", TitleName)
        formdata.append("SubTitleName", SubTitleName)
        formdata.append("Description", Description)
        formdata.append("Video_PurchaseAmount", Video_PurchaseAmount)
        formdata.append("M_UserID", M_UserID)

        appendVideoFormData(formdata, videoList, isUpdate, "SeminarVideoDetailID")

        const method = isUpdate ? "PATCH" : "POST"
        const url = isUpdate
            ? BaseUrl + "/Master/M_SeminarVideoMaster_Update"
            : BaseUrl + "/Master/M_SeminarVideoMaster_Insert"

        try {
            const response = await fetch(url, {
                method: method,
                headers: myHeaders,
                body: formdata,
                redirect: "follow",
            })
            const result = await response.json()

            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                if (handleIsPost) handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            if (setloader) setloader(false)
            return result
        } catch (error) {
            toastError("Something went wrong")
            if (setloader) setloader(false)
            throw error
        }
    }
)

const POST_M_SeminarVideoMaster_InsertSlice = createSlice({
    name: "POST_M_SeminarVideoMaster_Insert",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(POST_M_SeminarVideoMaster_InsertAPI.pending, (state) => {
            state.isPostLoading = true
            state.isError = false
        })
        builder.addCase(POST_M_SeminarVideoMaster_InsertAPI.fulfilled, (state, action) => {
            state.isPostLoading = false
            state.isError = false
            state.PostData = action.payload
        })
        builder.addCase(POST_M_SeminarVideoMaster_InsertAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message)
            state.isPostLoading = false
            state.isError = true
            state.PostData = null
        })
    },
})

export const POST_M_SeminarVideoMaster_InsertReducer = POST_M_SeminarVideoMaster_InsertSlice.reducer


// delete
export const M_SeminarVideoMaster_DeleteAPI = createAsyncThunk("M_SeminarVideoMaster_Delete", async ({ data }) => {
    const {
        SeminarVideoID,
        M_UserID,
        token,
        handleIsPost,
        setloader,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var formdata = new FormData();
    formdata.append("SeminarVideoID", SeminarVideoID);
    formdata.append("M_UserID", M_UserID);

    const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/M_SeminarVideoMaster_Delete`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                handleIsPost && handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            setloader && setloader(false)
            return result
        })
        .catch((error) => {
            toastError("Something went wrong")
            setloader && setloader(false)
            throw error
        })
})

const M_SeminarVideoMaster_DeleteSlice = createSlice({
    name: "M_SeminarVideoMaster_Delete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_SeminarVideoMaster_DeleteAPI.pending, (state) => {
            state.isDeleteLoading = true;
            state.isError = false;
        });
        builder.addCase(M_SeminarVideoMaster_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.isError = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(M_SeminarVideoMaster_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;
        });
    },
})

export const M_SeminarVideoMaster_DeleteReducer = M_SeminarVideoMaster_DeleteSlice.reducer


// get data
export const GET_M_SeminarVideoMaster_SelectAPI = createAsyncThunk("GET_M_SeminarVideoMaster_Select", async ({ data }) => {
    const {
        SeminarVideoID,
        SearchTerm,
        // FromDate,
        // ToDate,
        Flag,
        M_UserID,
        Language,
        FromTop,
        ToTop,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/Get_M_SeminarVideoMaster_Select?SeminarVideoID=${SeminarVideoID}&SearchTerm=${encodeURIComponent(SearchTerm ?? "")}&Flag=${Flag}&M_UserID=${M_UserID}&Language=${Language}&FromTop=${FromTop}&ToTop=${ToTop}` // &FromDate=${FromDate}&ToDate=${ToDate}

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result?.data?.table) {
                return result.data.table
            } else {
                return result
            }
        })
})

const GET_M_SeminarVideoMaster_SelectSlice = createSlice({
    name: "GET_M_SeminarVideoMaster_Select",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GET_M_SeminarVideoMaster_SelectAPI.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
            state.TableData = [];
        });
        builder.addCase(GET_M_SeminarVideoMaster_SelectAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.TableData = action.payload;
        });
        builder.addCase(GET_M_SeminarVideoMaster_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
        });
    },
})

export const GET_M_SeminarVideoMaster_SelectReducer = GET_M_SeminarVideoMaster_SelectSlice.reducer